import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchDailySentenceById } from "./dailySentenceService";
import "./DailySentenceDetailPage.css";

const levelColor = (l) => {
 const map = { EASY: "#4caf50", MEDIUM: "#ff9800", HARD: "#e91e63" };
 return map[l?.toUpperCase()] || "#999";
};

const DailySentenceDetailPage = () => {
 const { id } = useParams();
 const navigate = useNavigate();
 const [sentence, setSentence] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 const load = async () => {
 setLoading(true);
 const res = await fetchDailySentenceById(id);
 if (res.status === 200 && res.data?.status) {
 setSentence(res.data.data);
 } else {
 }
 setLoading(false);
 };
 load();
 }, [id]);

 if (loading) return (<><Navbar /><div className="dsd-page"><p className="dsd-loading">Loading...</p></div><Footer /></>);

 if (!sentence) return (
 <>
 <Navbar />
 <div className="dsd-page">
 <p className="dsd-loading">Sentence not found.</p>
 <button className="dsd-back" onClick={() => navigate("/study/daily-sentences")}>← Back</button>
 </div>
 <Footer />
 </>
 );

 return (
 <>
 <Navbar />
 <div className="dsd-page">
 <button className="dsd-back" onClick={() => navigate(
 sentence.categoryId
 ? `/study/daily-sentences/category/${sentence.categoryId}`
 : "/study/daily-sentences"
 )}>
 ← Back to {sentence.categoryTitle || "Daily Sentences"}
 </button>

 <div className="dsd-hero">
 <div className="dsd-tags">
 <span className="dsd-category">{sentence.categoryTitle || sentence.categoryName}</span>
 <span className="dsd-level" style={{ background: levelColor(sentence.level) }}>
 {sentence.levelDisplayName || sentence.level}
 </span>
 </div>
 <h1 className="dsd-title">{sentence.title}</h1>
 </div>

 {(sentence.pronunciation || sentence.phoneticSpelling) && (
 <div className="dsd-card">
 <h3 className="dsd-card-title">🗣️ Pronunciation</h3>
 <div className="dsd-pron-row">
 {sentence.pronunciation && (
 <div className="dsd-pron-item">
 <span className="dsd-pron-label">
 IPA
 <Link to="/study/ipa/lessons" className="dsd-ipa-info" title="Learn IPA symbols">ℹ</Link>
 </span>
 <span className="dsd-pron-value">{sentence.pronunciation}</span>
 </div>
 )}
 {sentence.phoneticSpelling && (
 <div className="dsd-pron-item">
 <span className="dsd-pron-label">How to say</span>
 <span className="dsd-pron-value phonetic">{sentence.phoneticSpelling}</span>
 </div>
 )}
 </div>
 </div>
 )}

 {sentence.description && (
 <div className="dsd-card">
 <h3 className="dsd-card-title">📝 Meaning</h3>
 <p className="dsd-card-text">{sentence.description}</p>
 </div>
 )}

 {sentence.createdAt && (
 <p className="dsd-meta">
 Added on{" "}
 {new Date(sentence.createdAt).toLocaleDateString("en-IN", {
 day: "numeric", month: "short", year: "numeric",
 })}
 </p>
 )}
 </div>
 <Footer />
 </>
 );
};

export default DailySentenceDetailPage;
